import { URLAuth } from 'environments/interfaces';
import { UserManagerSettings, WebStorageStateStore, OidcMetadata } from "oidc-client";
import { WSO2AuthLocalStorageNames } from 'enuns/WSO2AuthLocalStorageNames';

export const getWSO2AccessTokenInPath = (): string | null => {
  if (window.location.hash) {
    return window.location.hash.substring(window.location.hash.indexOf('=') + 1, window.location.hash.indexOf('&'));
  }
  return null;
}

export const getWSO2IdTokenInPath = (): string | null => {
  if (window.location.hash) {
    return window.location.hash.substring(window.location.hash.indexOf('id_token=') + 9, window.location.hash.indexOf('&token_type'));
  }
  return null;
}

export const getWSO2LocalStorageAccessToken = (): string | null => {
  return window.localStorage.getItem(WSO2AuthLocalStorageNames.AccessToken);
}

export const getWSO2LocalStorageIdToken = (): string | null => {
  return window.localStorage.getItem(WSO2AuthLocalStorageNames.IdToken);
}

export const isAuthenticated = () => {
  const access_token = window.localStorage.getItem(WSO2AuthLocalStorageNames.AccessToken);
  return !!access_token;
};

const getOidcMetadata = (authEnvironment: URLAuth): Partial<OidcMetadata> => {
  return {
    issuer: authEnvironment.tokenUrl,
    jwks_uri:
      authEnvironment.authUrl + "/.well-known/openid-configuration/jwks",
    authorization_endpoint: authEnvironment.authUrl,
    token_endpoint: authEnvironment.authUrl + "/connect/token",
    userinfo_endpoint: authEnvironment.authUrl + "/connect/userinfo",
    end_session_endpoint: authEnvironment.authUrl + "/connect/endsession",
    check_session_iframe:
      authEnvironment.authUrl + "/connect/checksession",
    revocation_endpoint: authEnvironment.authUrl + "/connect/revocation",
    introspection_endpoint: authEnvironment.authUrl + "/connect/introspect"
  };
}

export const getWSO2UserManagerSettings = (authEnvironment: URLAuth): UserManagerSettings => {
  return {
    authority: authEnvironment.authUrl,
    client_id: authEnvironment.identityClientId,
    redirect_uri: authEnvironment.redirectUrl,
    silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URL,
    post_logout_redirect_uri: authEnvironment.logofRedirectUrl,
    // audience: "your audience",
    response_type: "id_token token",
    automaticSilentRenew: false,
    loadUserInfo: false,
    scope: "openid profile email",
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    metadata: getOidcMetadata(authEnvironment)
  }
}